import {Component, Inject} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ConfigurationService } from './services/configuration.service';
import { AuthenticationService } from './services/authentication.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: []
})
export class AppComponent {
  name = '';
  userAlias = '';
  pages = [];

  constructor(
    @Inject('ConfigurationService') private readonly configurationService: ConfigurationService,
    @Inject('AuthenticationService') private readonly authenticationService: AuthenticationService,
    private readonly titleService: Title) {
  }

  ngOnInit(){
    forkJoin(
      this.configurationService.getConfiguration(),
      this.authenticationService.getAuthenticated()
    ).subscribe(([config, _]) => {
      this.name = config.name || '';
      this.titleService.setTitle(this.name || 'RESTool');
      this.pages = config.pages || [];
      try {
        const user = this.authenticationService.getUserDetails();
        this.userAlias = user['alias'] || '';
      } catch (e) {
        this.userAlias = '';
      }
    })
  }
}
